import React, { useEffect, useMemo, useState } from "react";
import {
  Layout,
  Card,
  Typography,
  Select,
  Row,
  Col,
  Table,
  Tag,
  Space,
  Spin,
  Empty,
  Progress,
  Statistic,
  message,
  Button,
  Input,
  DatePicker,
  AutoComplete,
} from "antd";

import { useSearchParams } from 'react-router-dom';

import {
  ApiOutlined,
  ThunderboltOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  MailOutlined,
  PhoneOutlined,
  DatabaseOutlined,
  RiseOutlined,
} from "@ant-design/icons";

import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  PieChart,
  Pie,
  Cell,
} from "recharts";

import Sidebar from "../components/Sidebar";
import AppHeader from "../components/Header";
import "./API.css";

import { decryptData } from '../middleware/encryption';

const { Content } = Layout;
const { Title, Text } = Typography;

const { RangePicker } = DatePicker;

const API_BASE_URL = "https://api.app.exellius.com/api/v1";


const role = sessionStorage.getItem('role');
const formatCredits = (credits) => {
    if (!credits && credits !== 0) return '-';
    if (credits >= 1000) return `${(credits / 1000).toFixed(1)}K`;
    return credits;
  };

export default function API() {
  const [collapsed, setCollapsed] = useState(false);

  const [range, setRange] = useState("30d");

  const [loading, setLoading] = useState(true);
  const [detailsLoading, setDetailsLoading] = useState(false);

  const [dashboard, setDashboard] = useState(null);

  const [usageDetails, setUsageDetails] = useState([]);

  const [page, setPage] = useState(1);

  const [creditsRemaining, setCreditsRemaining] = useState(0);

  const [usageData, setUsageData] = useState();

  const [detailsPagination, setDetailsPagination] = useState({
    total: 0,
    limit: 10,
    page: 1,
  });

const [searchParams] = useSearchParams();
  const [selectedRange, setSelectedRange] = useState("7d");
const [customDateRange, setCustomDateRange] = useState(null);



  const [userEmail, setUserEmail] = useState("");
const [selectedUser, setSelectedUser] = useState(null);
const [userSearching, setUserSearching] = useState(false);
  const [userOptions, setUserOptions] = useState([]);

const [dashboardLoading, setDashboardLoading] = useState(false);

const [dateRange, setDateRange] = useState("30d");
  // =========================================================
  // TOKEN
  // =========================================================

  const getToken = () => {
    return sessionStorage.getItem('access_token');
  };


  const searchUserByEmail = async () => {
  const email = userEmail.trim();

  if (!email) {
   
    return;
  }

  setUserSearching(true);

  try {
    const token =
      sessionStorage.getItem("access_token");

    const myHeaders = new Headers();

    if (token) {
      myHeaders.append(
        "Authorization",
        `Bearer ${token}`
      );
    }

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    const url =
      `https://api.app.exellius.com/api/users/getUsersWithActivePlans` +
      `?page=1` +
      `&limit=10` +
      `&search=${encodeURIComponent(email)}`;

    const response = await fetch(
      url,
      requestOptions
    );

    const result = await response.json();

    if (!result.data) {
     
      return;
    }

    const decryptedResponse =
      decryptData(result.data);

    console.log(
      "User search result:",
      decryptedResponse
    );

    const users =
      decryptedResponse?.users || [];

    if (users.length === 0) {
      setSelectedUser(null);
      setDashboard(null);

     

      return;
    }

    // Find exact email match
    const matchedUser =
      users.find(
        (user) =>
          user.email?.toLowerCase() ===
          email.toLowerCase()
      ) || users[0];

    console.log(
      "Selected user:",
      matchedUser
    );

   setSelectedUser(matchedUser);

   

await fetchDashboard(
  dateRange,
  matchedUser.user_id
);
  } catch (error) {
    console.error(
      "User search error:",
      error
    );

   
  } finally {
    setUserSearching(false);
  }
};

  const fetchUserSuggestions = async (query) => {
    if (!query || query.trim().length === 0) {
      setUserOptions([]);
      return;
    }

    try {
      const token = getToken();
      const myHeaders = new Headers();

      if (token) myHeaders.append("Authorization", `Bearer ${token}`);

      const url =
        `https://api.app.exellius.com/api/users/getUsersWithActivePlans` +
        `?page=1` +
        `&limit=10` +
        `&search=${encodeURIComponent(query)}`;

      const response = await fetch(url, { method: "GET", headers: myHeaders });
      const result = await response.json();

      if (!result.data) {
        setUserOptions([]);
        return;
      }

      const decryptedResponse = decryptData(result.data);
      const users = decryptedResponse?.users || [];

      const options = users.map((u) => ({
        value: u.email,
        label: `${u.name || u.email} <${u.email}>`,
        user: u,
      }));

      setUserOptions(options);
    } catch (err) {
      console.error("Error fetching user suggestions:", err);
      setUserOptions([]);
    }
  };


  const fetchUserCredits = async () => {
      setLoading(true);
      try {
        const token = sessionStorage.getItem('access_token');
        const myHeaders = new Headers();
  
        console.log(token);
        if (token) myHeaders.append("Authorization", `Bearer ${token}`);
  
        const response = await fetch("https://api.app.exellius.com/api/users/getUserPoints", {
          method: "GET",
          headers: myHeaders
        });
  
        const result = await response.json();
        if (result.data) {
          const decryptedResponse = decryptData(result.data);
          setUsageData(decryptedResponse.points);
        } else {
        
        }
      } catch (error) {
        console.error('Error fetching user credits:', error);
       
      }
      setLoading(false);
    };

  // =========================================================
  // FETCH DASHBOARD
  // =========================================================

  const fetchDashboard = async (
  range,
  userId = null,
  dates = null
) => {
  try {
    setLoading(true);

    const token = getToken();

    const params = new URLSearchParams();

    params.append("range", range);

    if (userId) {
      params.append("user_id", userId);
    }

    const rapidId = searchParams.get('rapid_id');

    if (rapidId) {
      params.append("rapid_id", rapidId);
    }

    if (
      range === "custom" &&
      dates &&
      dates.length === 2
    ) {
      params.append(
        "start_date",
        dates[0].format("YYYY-MM-DD")
      );

      params.append(
        "end_date",
        dates[1].format("YYYY-MM-DD")
      );
    }

    const url =
      `${API_BASE_URL}/analytics/dashboard?${params.toString()}`;

    console.log("Analytics URL:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to load dashboard");
    }

    const result = await response.json();

    console.log("Dashboard:", result);

    setDashboard(result?.data || result);

  } catch (error) {

    console.error(
      "Dashboard error:",
      error
    );

  } finally {

    setLoading(false);

  }
};
  // =========================================================
  // FETCH USAGE DETAILS
  // =========================================================

  const fetchUsageDetails = async (currentPage = 1) => {
    try {
      setDetailsLoading(true);

      const token = getToken();

      const response = await fetch(
        `${API_BASE_URL}/analytics/usage-details?range=${range}&page=${currentPage}&limit=20`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch usage details");
      }

      const data = await response.json();

      console.log("Usage details fetched:", data);

      /*
       * Based on your existing working response:
       *
       * setUsageDetails(data?.data || []);
       */

      const rows = Array.isArray(data?.data)
        ? data.data
        : Array.isArray(data?.data?.data)
        ? data.data.data
        : Array.isArray(data?.data?.rows)
        ? data.data.rows
        : [];

      setUsageDetails(rows);

      const pagination =
        data?.pagination ||
        data?.data?.pagination ||
        {};

      setDetailsPagination({
        total: Number(pagination.total || rows.length),
        limit: Number(pagination.limit || 20),
        page: currentPage,
      });
    } catch (error) {
      console.error("Usage details error:", error);

   

      setUsageDetails([]);
    } finally {
      setDetailsLoading(false);
    }
  };

  // =========================================================
  // INITIAL LOAD / RANGE CHANGE
  // =========================================================

  useEffect(() => {
    setPage(1);

    fetchDashboard();
    fetchUsageDetails(1);
    fetchUserCredits();
  }, [range]);

  // =========================================================
  // NORMALIZE DASHBOARD DATA
  // =========================================================


  const stats = dashboard?.summary || {};

const totalCredits = Number(
  stats.total_credits_used || 0
);

const totalRequests = Number(
  stats.total_api_requests || 0
);

const avgResponseTime = Number(
  stats.avg_response_time_ms || 0
);

const successRate = Number(
  stats.success_rate || 0
);

// =========================================================
// CREDIT BREAKDOWN
// =========================================================

const creditBreakdown =
  dashboard?.credit_breakdown || [];

// Email found
const emailFound = creditBreakdown.reduce(
  (total, item) =>
    total +
    Number(item.email_found_count || 0),
  0
);

// Phone found
const phoneFound = creditBreakdown.reduce(
  (total, item) =>
    total +
    Number(item.phone_found_count || 0),
  0
);
  // =========================================================
  // BREAKDOWN
  // =========================================================

  const breakdown =
    dashboard?.credits_breakdown ||
    dashboard?.credit_breakdown ||
    [];

  const breakdownData =
    breakdown.length > 0
      ? breakdown
      : [
          {
            name: "Email Fetch",
            value: Number(
              dashboard?.email_credits || 0
            ),
          },
          {
            name: "Phone Fetch",
            value: Number(
              dashboard?.phone_credits || 0
            ),
          },
          {
            name: "No Data",
            value: Number(
              dashboard?.no_data_credits || 0
            ),
          },
        ];

 const pieData = creditBreakdown.map((item) => ({
  name: item.operation_type,
  value: Number(item.credits_used || 0),
  requests: Number(item.requests || 0),
  emailFound: Number(item.email_found_count || 0),
  phoneFound: Number(item.phone_found_count || 0),
}));

const totalPieCredits = pieData.reduce(
  (total, item) => total + item.value,
  0
);

const pieDataWithPercentage = pieData.map((item) => ({
  ...item,
  percentage:
    totalPieCredits > 0
      ? (item.value / totalPieCredits) * 100
      : 0,
}));
  // =========================================================
  // TREND
  // =========================================================

  const trendData =
  dashboard?.credit_over_time || [];

  // =========================================================
  // ENDPOINT DATA
  // =========================================================

  const endpointData =
  dashboard?.usage_by_endpoint || [];

  // =========================================================
  // TOP OPERATIONS
  // =========================================================

  const topOperations =
  dashboard?.top_credit_operations || [];

  // =========================================================
  // DAILY SUMMARY
  // =========================================================

 const dailySummary =
  dashboard?.daily_summary || {};
  // =========================================================
  // PIE COLORS
  // =========================================================

  const PIE_COLORS = [
    "#7950F2",
    "#3B82F6",
    "#34B27B",
    "#F59E0B",
  ];

  // =========================================================
  // TABLE COLUMNS
  // =========================================================

  const detailsColumns = useMemo(
    () => [
      {
        title: "Endpoint",
        dataIndex: "endpoint",
        key: "endpoint",
        width: 250,
        render: (value, record) => (
          <Space direction="vertical" size={3}>
            <Text strong>
              {value || "-"}
            </Text>

            <Tag color="blue">
              {record?.method || "GET"}
            </Tag>
          </Space>
        ),
      },

      {
        title: "Type",
        dataIndex: "lookup_type",
        key: "lookup_type",
        width: 100,
        render: (value) =>
          value ? (
            <Tag>
              {String(value).toUpperCase()}
            </Tag>
          ) : (
            "-"
          ),
      },

      {
        title: "Results",
        dataIndex: "results_count",
        key: "results_count",
        align: "right",
        width: 100,
        render: (value) =>
          Number(value || 0).toLocaleString(),
      },

      {
        title: "Email Found",
        dataIndex: "email_found_count",
        key: "email_found_count",
        align: "right",
        width: 120,
        render: (value) => (
          <Tag color="purple">
            <MailOutlined />{" "}
            {Number(value || 0).toLocaleString()}
          </Tag>
        ),
      },

      {
        title: "Phone Found",
        dataIndex: "phone_found_count",
        key: "phone_found_count",
        align: "right",
        width: 120,
        render: (value) => (
          <Tag color="blue">
            <PhoneOutlined />{" "}
            {Number(value || 0).toLocaleString()}
          </Tag>
        ),
      },

      {
        title: "Credits",
        dataIndex: "credits_used",
        key: "credits_used",
        align: "right",
        width: 100,
        render: (value) =>
          Number(value || 0).toLocaleString(),
      },

      {
        title: "Response",
        dataIndex: "response_time_ms",
        key: "response_time_ms",
        align: "right",
        width: 110,
        render: (value) =>
          `${Number(value || 0)} ms`,
      },

      {
        title: "Status",
        dataIndex: "success",
        key: "success",
        width: 100,
        render: (value) =>
          value ? (
            <Tag color="success">
              Success
            </Tag>
          ) : (
            <Tag color="error">
              Failed
            </Tag>
          ),
      },

      {
        title: "Date",
        dataIndex: "created_at",
        key: "created_at",
        width: 180,
        render: (value) =>
          value
            ? new Date(value).toLocaleString()
            : "-",
      },
    ],
    []
  );

  // =========================================================
  // ENDPOINT TABLE COLUMNS
  // =========================================================

  const endpointColumns = [
    {
      title: "Endpoint",
      dataIndex: "endpoint",
      key: "endpoint",
      render: (value) => (
        <Text strong>
          {value || "-"}
        </Text>
      ),
    },
    {
      title: "Requests",
      dataIndex: "requests",
      key: "requests",
      align: "right",
      render: (value) =>
        Number(value || 0).toLocaleString(),
    },
    {
      title: "Credits",
      dataIndex: "credits_used",
      key: "credits_used",
      align: "right",
      render: (value) =>
        Number(value || 0).toLocaleString(),
    },
    {
      title: "Success",
      dataIndex: "success_rate",
      key: "success_rate",
      align: "right",
      render: (value) => (
        <Tag color="success">
          {Number(value || 0).toFixed(2)}%
        </Tag>
      ),
    },
    {
      title: "Response",
      dataIndex: "avg_response_time_ms",
      key: "avg_response_time_ms",
      align: "right",
      render: (value) =>
        `${Number(value || 0)} ms`,
    },
  ];

  // =========================================================
  // LOADING
  // =========================================================

  if (loading) {
    return (
      <Layout style={{ minHeight: "100vh" }}>
        <Sidebar
          collapsed={collapsed}
          onCollapse={setCollapsed}
        />

        <Layout>
          <AppHeader />

          <Content className="api-dashboard-content">
            <div className="api-dashboard-loading">
              <Spin size="large" />
            </div>
          </Content>
        </Layout>
      </Layout>
    );
  }

  // =========================================================
  // UI
  // =========================================================

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar
        collapsed={collapsed}
        onCollapse={setCollapsed}
      />

      <Layout>
        <AppHeader />

        <Content className="api-dashboard-content">

          {/* ============================================= */}
          {/* HEADER */}
          {/* ============================================= */}

         {/* PAGE HEADER */}
<Row
  gutter={[24, 16]}
  align="middle"
  justify="space-between"
  style={{
    marginBottom: 24,
  }}
>
  {/* LEFT - TITLE */}
  <Col xs={24} xl={8}>
    <div>
      <Title
        level={3}
        style={{
          margin: 0,
          marginBottom: 4,
        }}
      >
        API Analytics
      </Title>

      <Text type="secondary">
        Monitor API usage, credits,
        performance and enrichment results.
      </Text>
      <br />
      {role === 'admin' && selectedUser && (
        <Text type="secondary">
          Viewing analytics for <Text strong>{selectedUser.email}</Text>
        </Text>
      )}
    </div>
  </Col>

  {/* RIGHT - CONTROLS */}
  <Col xs={24} xl={16}>
    <Row
      gutter={[12, 12]}
      justify="end"
      align="middle"
    >
      {/* EMAIL SEARCH */}
      {role === 'admin' && (
        <Col xs={24} md={18}>
          <Space.Compact
            style={{
              width: "100%",
            }}
        >
          <AutoComplete
            options={userOptions}
            value={userEmail}
            onSearch={(val) => fetchUserSuggestions(val)}
            onSelect={async (value, option) => {
              setUserEmail(value);

              const matchedUser = option?.user || null;

              if (matchedUser) {
                setSelectedUser(matchedUser);

                await fetchDashboard(
                  dateRange,
                  matchedUser.user_id
                );
              }
            }}
            onChange={(val) => setUserEmail(val)}
            style={{ flex: 1 }}
          >
            <Input
              placeholder="Enter user email"
              onPressEnter={searchUserByEmail}
              allowClear
              size="large"
            />
          </AutoComplete>

          <Button
            type="primary"
            size="large"
            loading={userSearching}
            onClick={searchUserByEmail}
          >
            Search
          </Button>
        </Space.Compact>
      </Col>
      )}

      {/* DATE RANGE */}
      <Col xs={24} md={6}>
        <Row gutter={12} align="middle">
  <Col>
    <Select
      value={selectedRange}
      onChange={(value) => {
        setSelectedRange(value);

        if (value !== "custom") {
          setCustomDateRange(null);

          fetchDashboard(
            value,
            selectedUser?.user_id || null
          );
        }
      }}
      options={[
        {
          value: "7d",
          label: "Last 7 days",
        },
        {
          value: "30d",
          label: "Last 30 days",
        },
        {
          value: "90d",
          label: "Last 90 days",
        },
        {
          value: "1y",
          label: "Last 1 year",
        },
        {
          value: "custom",
          label: "Custom date range",
        },
      ]}
    />
  </Col>

  {selectedRange === "custom" && (
    <Col >
      <RangePicker
      style={{ marginTop: 8 }}
        value={customDateRange}
        onChange={(dates) => {
          setCustomDateRange(dates);

          if (dates && dates.length === 2) {
            fetchDashboard(
              "custom",
              selectedUser?.user_id || null,
              dates
            );
          }
        }}
        format="YYYY-MM-DD"
        allowClear
      />
    </Col>
  )}
</Row>
      </Col>
    </Row>
  </Col>
</Row>


         

          {/* ============================================= */}
          {/* KPI CARDS */}
          {/* ============================================= */}

          <Row gutter={[16, 16]}>
  <Col xs={24} sm={12} lg={6} xl={5}>
    <Card 
      className="api-stat-card"
      style={{
        background: 'linear-gradient(135deg, #dde4ff 0%, #9bafff 100%)',
        
        borderRadius: '12px',
        
      }}
    >
      <Statistic
        title={<span >Total Credits Used</span>}
        value={totalCredits}
        valueStyle={{  fontSize: '28px' }}
      />
      <div className="stat-sub">
        <RiseOutlined style={{ marginRight: '8px' }} />
        Usage for selected period
      </div>
    </Card>
  </Col>

  <Col xs={24} sm={12} lg={6} xl={5}>
    <Card 
      className="api-stat-card"
      style={{
        background: 'linear-gradient(135deg, #fde9ff 0%, #f093fb 100%)',
        
        borderRadius: '12px',
        
      }}
    >
      <Statistic
        title={<span >Total API Requests</span>}
        value={totalRequests}
        valueStyle={{  fontSize: '28px' }}
      />
      <div className="stat-sub" >
        API requests processed
      </div>
    </Card>
  </Col>

  <Col xs={24} sm={12} lg={6} xl={5}>
    <Card 
      className="api-stat-card"
      style={{
        background: 'linear-gradient(135deg, #bce0ff 0%, #8a9eee 100%)',
       
        borderRadius: '12px',
       
      }}
    >
      <Statistic
        title={<span >Credits Remaining</span>}
        value={formatCredits(usageData)}
        valueStyle={{  fontSize: '28px' }}
      />
      <div className="stat-sub" >
        remaining credits in your account
      </div>
    </Card>
  </Col>

  <Col xs={24} sm={12} lg={6} xl={5}>
    <Card 
      className="api-stat-card"
      style={{
        background: 'linear-gradient(135deg, #ccf6da 0%, #78f5b9 100%)',
        
        borderRadius: '12px',
       
      }}
    >
      <Statistic
        title={<span style={{ color: 'rgba(0,0,0,0.7)' }}>Avg Response Time</span>}
        value={avgResponseTime}
        suffix="ms"
        valueStyle={{ color: '#1a3a2a', fontSize: '28px' }}
      />
      <div className="stat-sub" style={{ color: 'rgba(0,0,0,0.6)' }}>
        Average API performance
      </div>
    </Card>
  </Col>

  <Col xs={24} sm={12} lg={6} xl={4}>
    <Card 
      className="api-stat-card"
      style={{
        background: 'linear-gradient(135deg, #f6f7c2 0%, #fee140 100%)',
        
        borderRadius: '12px',
       
      }}
    >
      <Statistic
        title={<span style={{ color: 'rgba(0,0,0,0.7)' }}>Success Rate</span>}
        value={successRate}
        precision={2}
        suffix="%"
        valueStyle={{ color: '#2a1a0a', fontSize: '28px' }}
      />
      <div className="stat-sub" style={{ color: 'rgba(0,0,0,0.6)' }}>
        Successful requests
      </div>
    </Card>
  </Col>
</Row>


         <Row
  gutter={[16, 16]}
  style={{ marginTop: 16 }}
  align="stretch"
>
  {/* DONUT */}
  <Col xs={24} lg={12} className="dashboard-equal-col">
    <Card
      title="Credits Consumption Breakdown"
      className="dashboard-card dashboard-equal-card"
       style={{ height: '100%', minHeight: '460px' }}
    >
      {pieDataWithPercentage.length === 0 ||
      pieDataWithPercentage.every(
        (item) => item.value === 0
      ) ? (
        <Empty
          description="No credit usage data"
        />
      ) : (
        <div className="donut-container" style={{ display: 'flex', gap: '24px', height: '100%' }}>

          {/* DONUT CHART */}
          <div className="donut-chart">
            <ResponsiveContainer
              width="100%"
              height={270}
            >
              <PieChart>
                <Pie
                  data={pieDataWithPercentage}
                  cx="50%"
                  cy="50%"
                  innerRadius={70}
                  outerRadius={105}
                  paddingAngle={2}
                  dataKey="value"
                >
                  {pieDataWithPercentage.map(
                    (entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={
                          PIE_COLORS[
                            index %
                              PIE_COLORS.length
                          ]
                        }
                      />
                    )
                  )}
                </Pie>

                <Tooltip
                  formatter={(value, name, props) => {
                    const percentage =
                      props?.payload?.percentage || 0;

                    return [
                      `${Number(value).toLocaleString()} credits (${percentage.toFixed(2)}%)`,
                      name,
                    ];
                  }}
                />
              </PieChart>
            </ResponsiveContainer>

            <div className="donut-center">
              <Text>Total</Text>

              <strong>
                {totalCredits.toLocaleString()}
              </strong>

              <Text>Credits</Text>
            </div>
          </div>

          {/* BREAKDOWN */}
          <div className="breakdown-list">
            {pieDataWithPercentage.map(
              (item, index) => (
                <div
                  className="breakdown-item"
                  key={item.name}
                >
                  <div className="breakdown-name">
                    <span
                      className="legend-dot"
                      style={{
                        background:
                          PIE_COLORS[
                            index %
                              PIE_COLORS.length
                          ],
                      }}
                    />

                    <span>
                      {item.name}
                    </span>
                  </div>

                  <div className="breakdown-value">
                    <strong>
                      {item.value.toLocaleString()}
                    </strong>

                    <span className="breakdown-percentage">
                      (
                      {item.percentage.toFixed(2)}
                      %)
                    </span>
                  </div>
                </div>
              )
            )}

             <div className="credit-usage-note">
            <Text type="secondary">
              <strong>Credit usage:</strong>
            </Text>

            <div className="credit-note-item">
              <span className="legend-dot email-dot" />

              Every email found consumes{" "}
              <strong>1 credit</strong>
            </div>

            <div className="credit-note-item">
              <span className="legend-dot phone-dot" />

              Every phone found consumes{" "}
              <strong>5 credits</strong>
            </div>

            <div className="credit-note-item">
              <span className="legend-dot nodata-dot" />

              No data found consumes{" "}
              <strong>0 credits</strong>
            </div>
          </div>
          </div>

          

          
         

        </div>
        
      )}
    </Card>
  </Col>

  {/* TREND */}
  <Col xs={24} lg={12} className="dashboard-equal-col">
    <Card
      title="Credits Consumption Over Time"
      className="dashboard-card dashboard-equal-card"

      style={{ height: '100%', minHeight: '460px' }}
      extra={
        <Tag>
          Daily
        </Tag>
      }
    >
      <div className="trend-chart-container">
        <ResponsiveContainer
          width="100%"
          height={320}
        >
          <LineChart
            data={trendData}
            margin={{
              top: 10,
              right: 10,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid
              strokeDasharray="3 3"
            />

            <XAxis
              dataKey="date"
              tickFormatter={(value) =>
                new Date(value).toLocaleDateString(
                  "en-IN",
                  {
                    day: "2-digit",
                    month: "short",
                  }
                )
              }
            />

            <YAxis />

            <Tooltip
              labelFormatter={(value) =>
                new Date(value).toLocaleDateString(
                  "en-IN",
                  {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  }
                )
              }
            />

            <Legend />

            <Line
              type="monotone"
              dataKey="email_credits"
              name="Email Fetch"
              stroke="#7950F2"
              strokeWidth={2}
              dot={false}
            />

            <Line
              type="monotone"
              dataKey="phone_credits"
              name="Phone Fetch"
              stroke="#3B82F6"
              strokeWidth={2}
              dot={false}
            />

            <Line
              type="monotone"
              dataKey="no_data_credits"
              name="No Data"
              stroke="#34B27B"
              strokeWidth={2}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Card>
  </Col>
</Row>
          {/* ============================================= */}
          {/* ENDPOINT + TOP OPERATIONS */}
          {/* ============================================= */}

          <Row
            gutter={[16, 16]}
            style={{ marginTop: 16 }}
          >

            {/* ENDPOINT */}

            <Col xs={24} xl={17}>
              <Card
                title="Usage by Endpoint"
                className="dashboard-card"
                style={{ height: '100%' }}
              >
                <Table
                  rowKey={(record, index) =>
                    record.id ||
                    record.endpoint ||
                    index
                  }
                  columns={endpointColumns}
                  dataSource={endpointData}
                  pagination={{
                    pageSize: 7,
                    showSizeChanger: false,
                  }}
                  scroll={{
                    x: 850,
                  }}
                  size="small"
                />
              </Card>
            </Col>

            {/* TOP OPERATIONS */}

            <Col xs={24} xl={7}>
  <Card
    title="Top Credit Consuming Operations"
    className="dashboard-card top-operations-card"
  >
    {topOperations.length === 0 ? (
      <Empty
        description="No credit usage data"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    ) : (
      <div className="top-operations-list">
        {topOperations.map((item, index) => {
          const value = Number(
            item.credits_used || 0
          );

          const percentage = Number(
            item.percentage || 0
          );

          return (
            <div
              className="operation-item"
              key={
                item.operation || index
              }
            >
              {/* HEADER */}
              <div className="operation-header">
                <div className="operation-title">
                 

                  <div>
                    <Text strong>
                      {item.operation ||
                        "Unknown"}
                    </Text>

                    <div className="operation-subtitle">
                      {value.toLocaleString()} credits
                    </div>
                  </div>
                </div>

                <div className="operation-percentage">
                  <Text strong>
                    {percentage.toFixed(1)}%
                  </Text>
                </div>
              </div>

              {/* PROGRESS */}
              <Progress
                percent={Math.min(
                  percentage,
                  100
                )}
                showInfo={false}
                size="small"
                strokeLinecap="round"
              />

              {/* FOOTER */}
              
            </div>
          );
        })}
      </div>
    )}

   
  </Card>
</Col>
          </Row>

          {/* ============================================= */}
          {/* DAILY SUMMARY */}
          {/* ============================================= */}

          <Card
            title="Daily Usage Summary"
            className="dashboard-card"
            style={{ marginTop: 16 }}
          >
            <Row gutter={[16, 16]}>
              <Col xs={12} md={6}>
                <div className="summary-box">
                  <Text type="secondary">
                    Peak Day
                  </Text>

                  <strong>
  {dailySummary.peak_day
    ? new Date(
        dailySummary.peak_day
      ).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    : "-"}
</strong>
                </div>
              </Col>

              <Col xs={12} md={6}>
                <div className="summary-box">
                  <Text type="secondary">
                    Highest Credits Used
                  </Text>

                  <strong>
                    {Number(
                      dailySummary.highest_credits_used ||
                        0
                    ).toLocaleString()}
                  </strong>
                </div>
              </Col>

              <Col xs={12} md={6}>
                <div className="summary-box">
                  <Text type="secondary">
                    Highest Requests
                  </Text>

                  <strong>
                    {Number(
                      dailySummary.highest_requests ||
                        0
                    ).toLocaleString()}
                  </strong>
                </div>
              </Col>

              <Col xs={12} md={6}>
                <div className="summary-box">
                  <Text type="secondary">
                    Lowest Response Time
                  </Text>

                  <strong>
                    {Number(
                      dailySummary.lowest_response_time ||
                        0
                    )}{" "}
                    ms
                  </strong>
                </div>
              </Col>
            </Row>
          </Card>

          {/* ============================================= */}
          {/* API USAGE DETAILS */}
          {/* ============================================= */}
{/*
          <Card
            title="API Usage Details"
            className="dashboard-card"
            style={{
              marginTop: 16,
              marginBottom: 30,
            }}
          >
            <Table
              rowKey={(record) => record.id}
              loading={detailsLoading}
              columns={detailsColumns}
              dataSource={usageDetails}
              scroll={{
                x: 1200,
              }}
              pagination={{
                current: page,
                pageSize:
                  detailsPagination.limit ||
                  10,
                total:
                  detailsPagination.total ||
                  0,
                showSizeChanger: false,

                showTotal: (
                  total,
                  currentRange
                ) =>
                  `${currentRange[0]}-${currentRange[1]} of ${total}`,

                onChange: (nextPage) => {
                  setPage(nextPage);
                  fetchUsageDetails(
                    nextPage
                  );
                },
              }}
            />
          </Card>

           */}
        </Content>
      </Layout>
    </Layout>
  );
}